import { GridColDef } from "@mui/x-data-grid-pro";
import { Checkbox } from "@mui/material";

/**
 * GenerateEntregueColumnsDefinition
 */

type EntregueProps = {
  onToggleEntregue: (idDocumentoEntregue: number, idDocumento: number, state: boolean) => void,
  onToggleNaoSeAplica: (idDocumentoEntregue: number, idDocumento: number, state: boolean) => void,
};

export const GenerateEntregueColumnsDefinition = ({
  onToggleEntregue,
  onToggleNaoSeAplica,
}: EntregueProps): GridColDef[] => {
  return [
    {
      field: "entregue",
      filterable: false,
      headerName: "Entregue",
      flex: 0,
      minWidth: 80,
      sortable: false,
      headerClassName: 'funcionarios-header',
      valueGetter: (_, rows) => ({
        idDocumentoEntregue: rows['idDocumentoEntregue'],
        idDocumento: rows['idDocumento'],
        value: rows['entregue']
      }),
      renderCell: (params) => {
        return <Checkbox checked={params.value['value']} onChange={(_, checked) => onToggleEntregue(
          params.value['idDocumentoEntregue'],
          params.value['idDocumento'],
          checked,
        )} />;
      },
    },
    {
      field: "naoSeAplica",
      filterable: false,
      headerName: "Não se aplica",
      minWidth: 150,
      flex: 0,
      sortable: false,
      headerClassName: 'funcionarios-header',
      valueGetter: (_, rows) => ({
        idDocumentoEntregue: rows['idDocumentoEntregue'],
        idDocumento: rows['idDocumento'],
        value: rows['naoSeAplica']
      }),
      renderCell: (params) => {
        return <Checkbox checked={params.value['value']} onChange={(_, checked) => onToggleNaoSeAplica(
          params.value['idDocumentoEntregue'],
          params.value['idDocumento'],
          checked,
        )} />;
      },
    },
    {
      field: "observacao",
      filterable: false,
      headerName: "Observação",
      minWidth: 150,
      flex: 2,
      sortable: false,
      headerClassName: 'funcionarios-header'
    }
  ];
}